import React from 'react';
import { GroupFilter } from '../../../components/filter/Filters';
import { TabView } from '../../../components/tab/TabView';
import { useFilter } from '../../../controllers/useFilter';
import {
    ApprovedTeamTimesheetRequests,
    PendingTimesheetRequests,
    RejectedTeamTimesheetRequests,
} from './TimesheetTable';

export const TeamTimesheetRequestTab = props => {
  let {route: {params} = {}} = props;
  let {filterValues, searchValue, onChangeFilter, applyFilter} = useFilter({});
  let {filter, params: filterParams = {}} = filterValues;
  let {organization, product, period, ...rest} = params;

  params = {
    ...filterValues,
    ...filterParams,
    ...rest,
    product,
    organization,
  };
  const tabs = {
    pending: {
      label: 'Open',
      view: (
        <PendingTimesheetRequests
          filterParams={filterParams}
          filter={filter}
          params={params}
          {...props}
        />
      ),
      actions: [
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              type: 'autoComplete',
              label: 'Employee',
              api: '/employeeSuggestions',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'employee',
              searchFields: ['name', 'official_email_id', 'employee_code'],
            },
          ]}
        />,
      ],
    },
    approved: {
      label: 'Closed',
      view: (
        <ApprovedTeamTimesheetRequests
          filterParams={filterParams}
          filter={filter}
          params={params}
          {...props}
        />
      ),
      actions: [
        <GroupFilter
          filterValues={filterValues}
          applyFilter={applyFilter}
          filters={[
            {
              type: 'autoComplete',
              label: 'Employee',
              api: '/employeeSuggestions',
              placeholder: 'Select',
              suggestionField: 'name',
              valueField: 'name',
              field: 'employee',
              searchFields: ['name', 'official_email_id', 'employee_code'],
            },
          ]}
        />,
      ],
    },
    // rejected: {
    //   label: 'Rejected',
    //   view: (
    //     <RejectedTeamTimesheetRequests
    //       filterParams={filterParams}
    //       filter={filter}
    //       params={params}
    //       {...props}
    //     />
    //   ),
    //   actions: [
    //     <GroupFilter
    //       filterValues={filterValues}
    //       applyFilter={applyFilter}
    //       filters={[
    //         {
    //           type: 'autoComplete',
    //           label: 'Employee',
    //           api: '/employeeSuggestions',
    //           placeholder: 'Select',
    //           suggestionField: 'name',
    //           valueField: 'name',
    //           field: 'employee',
    //           searchFields: ['name', 'official_email_id', 'employee_code'],
    //         },
    //       ]}
    //     />,
    //   ],
    // },
  };
  return <TabView tabs={tabs} params={params} {...props} />;
};
